import { routes } from "@/constants/routes";
import { Redirect } from "expo-router";

/** Die Tiere-Konfiguration gibt es nicht mehr. Fälle liegen unter Meine Tiere. */
export default function ConfigAnimalsRedirect() {
  return <Redirect href={routes.myAnimals} />;
}
